import { Box, ContainerProps, SxProps, Theme } from '@mui/material';
import { CenterContainer } from '@/components/blocks/CenterContainer';
import { combineSX } from '@/utils/combineSX';

export interface DpContainerProps extends ContainerProps {
	framesx?: SxProps<Theme>;
	withoutmargin?: boolean;
	isPLP?: boolean;
}

export const DpContainer: React.FC<React.PropsWithChildren<DpContainerProps>> = ({
	children,
	component,
	framesx,
	withoutmargin,
	isPLP,
	...props
}) => (
	<Box
		component={component}
		sx={combineSX([
			{
				width: '100vw',
				display: 'flex',
				justifyContent: 'center',
				marginBottom: {
					xs: withoutmargin ? '0px' : '40px',
					sm: withoutmargin ? '0px' : '80px',
				},
			},
			...(Array.isArray(framesx) ? framesx : [framesx]),
		])}
	>
		<CenterContainer {...props} isPlP={isPLP ?? false}>
			{children}
		</CenterContainer>
	</Box>
);
